// extracted by mini-css-extract-plugin
module.exports = {"label_container":"AddTodoForm_label_container__37U-i","add_button":"AddTodoForm_add_button__3pW7Z"};